import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]
  declare readonly dialogTarget: HTMLElement

  closeDialogIfBlurred({ currentTarget, relatedTarget }: FocusEvent): void {
    const containsFocus = (currentTarget as HTMLElement).contains(
      (relatedTarget as HTMLElement) || document.activeElement
    )

    if (!containsFocus) {
      this.dialogTarget.hidden = true
      this.dispatch("dialogClosed")
    }
  }

  openDialog(): void {
    this.dialogTarget.hidden = false
  }
}
